import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const EndocrineOestrogenDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const cyp19a1 = getGenePalette(geneColors.CYP19A1);
  const esr1 = getGenePalette(geneColors.ESR1);
  const esr2 = getGenePalette(geneColors.ESR2);
  const hsd17b1 = getGenePalette(geneColors.HSD17B1);
  const cyp3a4 = getGenePalette(geneColors.CYP3A4);
  const ugt_sult = getGenePalette(geneColors["UGT/SULT"]);
  const cyp1a1 = getGenePalette(geneColors.CYP1A1);
  const comt = getGenePalette(geneColors.COMT);
  const cyp1b1 = getGenePalette(geneColors.CYP1B1);
  const nqo1 = getGenePalette(geneColors.NQO1);
  const hsd3b1 = getGenePalette(geneColors.HSD3B1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18293_224291)">
        <rect width={1540} height={914} transform="translate(0 204)" fill="white" />
        <g id="endocrine-oestrogen-diagram">
          <rect width={1540} height={914} transform="translate(0 204)" fill="white" />
          <g id="lines">
            <path
              id="Vector_2"
              d="M506.5 550.5L1519.5 550.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M414.042 406L418.083 399L410 399L414.042 406ZM414.742 322.7C414.742 322.313 414.428 322 414.042 322C413.655 322 413.342 322.313 413.342 322.7L414.042 322.7L414.742 322.7ZM414.742 403.917C414.742 403.531 414.428 403.218 414.042 403.218C413.655 403.218 413.342 403.531 413.342 403.918L414.042 403.918L414.742 403.917ZM413.342 399.753C413.342 400.139 413.655 400.453 414.042 400.453C414.428 400.453 414.742 400.139 414.742 399.753L414.042 399.753L413.342 399.753ZM414.742 395.587C414.742 395.201 414.428 394.887 414.042 394.887C413.655 394.887 413.342 395.201 413.342 395.587L414.042 395.587L414.742 395.587ZM413.342 391.422C413.342 391.809 413.655 392.123 414.042 392.123C414.428 392.123 414.742 391.809 414.742 391.422L414.042 391.422L413.342 391.422ZM414.742 387.257C414.742 386.871 414.428 386.558 414.042 386.558C413.655 386.558 413.342 386.871 413.342 387.257L414.042 387.257L414.742 387.257ZM413.342 383.092C413.342 383.479 413.655 383.792 414.042 383.792C414.428 383.792 414.742 383.479 414.742 383.092L414.042 383.092L413.342 383.092ZM414.742 378.927C414.742 378.541 414.428 378.227 414.042 378.227C413.655 378.227 413.342 378.541 413.342 378.927L414.042 378.927L414.742 378.927ZM413.342 374.762C413.342 375.149 413.655 375.462 414.042 375.462C414.428 375.462 414.742 375.149 414.742 374.762L414.042 374.762L413.342 374.762ZM414.742 370.597C414.742 370.211 414.428 369.897 414.042 369.897C413.655 369.897 413.342 370.211 413.342 370.597L414.042 370.597L414.742 370.597ZM413.342 366.432C413.342 366.819 413.655 367.132 414.042 367.132C414.428 367.132 414.742 366.819 414.742 366.432L414.042 366.432L413.342 366.432ZM414.742 362.267C414.742 361.881 414.428 361.567 414.042 361.567C413.655 361.567 413.342 361.881 413.342 362.267L414.042 362.267L414.742 362.267ZM413.342 358.102C413.342 358.489 413.655 358.802 414.042 358.802C414.428 358.802 414.742 358.489 414.742 358.102L414.042 358.102L413.342 358.102ZM414.742 353.937C414.742 353.551 414.428 353.237 414.042 353.237C413.655 353.237 413.342 353.551 413.342 353.937L414.042 353.937L414.742 353.937ZM413.342 349.772C413.342 350.159 413.655 350.472 414.042 350.472C414.428 350.472 414.742 350.159 414.742 349.772L414.042 349.772L413.342 349.772ZM414.742 345.607C414.742 345.221 414.428 344.907 414.042 344.907C413.655 344.907 413.342 345.221 413.342 345.607L414.042 345.607L414.742 345.607ZM413.342 341.442C413.342 341.829 413.655 342.142 414.042 342.142C414.428 342.142 414.742 341.829 414.742 341.442L414.042 341.442L413.342 341.442ZM414.742 337.277C414.742 336.891 414.428 336.577 414.042 336.577C413.655 336.577 413.342 336.891 413.342 337.277L414.042 337.277L414.742 337.277ZM413.342 333.112C413.342 333.499 413.655 333.812 414.042 333.812C414.428 333.812 414.742 333.499 414.742 333.112L414.042 333.112L413.342 333.112ZM414.742 328.947C414.742 328.561 414.428 328.247 414.042 328.247C413.655 328.247 413.342 328.561 413.342 328.947L414.042 328.947L414.742 328.947ZM413.342 324.782C413.342 325.169 413.655 325.482 414.042 325.482C414.428 325.482 414.742 325.169 414.742 324.782L414.042 324.782L413.342 324.782ZM414.042 399.753L414.742 399.753L414.742 395.587L414.042 395.587L413.342 395.587L413.342 399.753L414.042 399.753ZM414.042 391.422L414.742 391.422L414.742 387.257L414.042 387.257L413.342 387.257L413.342 391.422L414.042 391.422ZM414.042 383.092L414.742 383.092L414.742 378.927L414.042 378.927L413.342 378.927L413.342 383.092L414.042 383.092ZM414.042 374.762L414.742 374.762L414.742 370.597L414.042 370.597L413.342 370.597L413.342 374.762L414.042 374.762ZM414.042 366.432L414.742 366.432L414.742 362.267L414.042 362.267L413.342 362.267L413.342 366.432L414.042 366.432ZM414.042 358.102L414.742 358.102L414.742 353.937L414.042 353.937L413.342 353.937L413.342 358.102L414.042 358.102ZM414.042 349.772L414.742 349.772L414.742 345.607L414.042 345.607L413.342 345.607L413.342 349.772L414.042 349.772ZM414.042 341.442L414.742 341.442L414.742 337.277L414.042 337.277L413.342 337.277L413.342 341.442L414.042 341.442ZM414.042 333.112L414.742 333.112L414.742 328.947L414.042 328.947L413.342 328.947L413.342 333.112L414.042 333.112ZM414.042 324.782L414.742 324.782L414.742 322.7L414.042 322.7L413.342 322.7L413.342 324.782L414.042 324.782Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_4"
              d="M415.042 481L419.083 474L411 474L415.042 481ZM415.742 405.7L415.742 405L414.342 405L414.342 405.7L415.042 405.7L415.742 405.7ZM415.042 474.7L415.742 474.7L415.742 405.7L415.042 405.7L414.342 405.7L414.342 474.7L415.042 474.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_5"
              d="M831.641 689.721L839.449 687.629L833.733 681.913L831.641 689.721ZM1023.5 498.848L1024 498.353L1023.01 497.363L1022.51 497.858L1023.01 498.353L1023.5 498.848ZM836.096 685.266L836.591 685.761L1023.5 498.848L1023.01 498.353L1022.51 497.858L835.601 684.771L836.096 685.266Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_6"
              d="M1046.04 718L1050.08 711L1042 711L1046.04 718ZM1046.74 513.7L1046.74 513L1045.34 513L1045.34 513.7L1046.04 513.7L1046.74 513.7ZM1046.04 711.7L1046.74 711.7L1046.74 513.7L1046.04 513.7L1045.34 513.7L1045.34 711.7L1046.04 711.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_6">
            <mask id="path-28-inside-2_18293_224291" fill="white">
              <path d="M1053 516L1248 516L1248 589L1053 589L1053 516Z" />
            </mask>
            <path
              d="M1053 589L1051.6 589L1051.6 590.4L1053 590.4L1053 589ZM1248 589L1248 587.6L1053 587.6L1053 589L1053 590.4L1248 590.4L1248 589ZM1053 589L1054.4 589L1054.4 516L1053 516L1051.6 516L1051.6 589L1053 589Z"
              fill="#1A1A1A"
              mask="url(#path-28-inside-2_18293_224291)"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_7"
              d="M506.5 462.5L1519.5 462.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
          </g>
          <g id="lines_8">
            <mask id="path-31-inside-3_18293_224291" fill="white">
              <path d="M1045 514L1241 514L1241 573L1045 573L1045 514Z" />
            </mask>
            <path
              d="M1241 573L1241 574.4L1242.4 574.4L1242.4 573L1241 573ZM1241 514L1239.6 514L1239.6 573L1241 573L1242.4 573L1242.4 514L1241 514ZM1241 573L1241 571.6L1045 571.6L1045 573L1045 574.4L1241 574.4L1241 573Z"
              fill="#1A1A1A"
              mask="url(#path-31-inside-3_18293_224291)"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_8"
              d="M324 620.042L317 616L317 624.083L324 620.042ZM248.7 619.342L248 619.342L248 620.742L248.7 620.742L248.7 620.042L248.7 619.342ZM317.7 620.042L317.7 619.342L248.7 619.342L248.7 620.042L248.7 620.742L317.7 620.742L317.7 620.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_10">
            <path
              id="Vector_9"
              d="M508 617.042L515 621.083L515 613L508 617.042ZM583.3 617.742L584 617.742L584 616.342L583.3 616.342L583.3 617.042L583.3 617.742ZM514.3 617.042L514.3 617.742L583.3 617.742L583.3 617.042L583.3 616.342L514.3 616.342L514.3 617.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_11">
            <path
              id="Vector_10"
              d="M1081 522.042L1088 526.083L1088 518L1081 522.042ZM1131.3 522.742L1132 522.742L1132 521.342L1131.3 521.342L1131.3 522.042L1131.3 522.742ZM1087.3 522.042L1087.3 522.742L1131.3 522.742L1131.3 522.042L1131.3 521.342L1087.3 521.342L1087.3 522.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_12">
            <path
              id="Vector_11"
              d="M1166.7 485.342L1166 485.342L1166 486.742L1166.7 486.742L1166.7 486.042L1166.7 485.342ZM1221 486.042L1214 482L1214 490.083L1221 486.042ZM1166.7 486.042L1166.7 486.742L1214.7 486.742L1214.7 486.042L1214.7 485.342L1166.7 485.342L1166.7 486.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_13">
            <path
              id="Vector_12"
              d="M1223.7 588.342L1223 588.342L1223 589.742L1223.7 589.742L1223.7 589.042L1223.7 588.342ZM1226 589.042L1219 585L1219 593.083L1226 589.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_14">
            <path
              id="Vector_13"
              d="M1069.8 573.658L1070.5 573.658L1070.5 572.258L1069.8 572.258L1069.8 572.958L1069.8 573.658ZM1065.5 572.958L1072.5 577L1072.5 568.917L1065.5 572.958Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_15">
            <path
              id="Vector_14"
              d="M1248.66 511.7L1248.66 511L1247.26 511L1247.26 511.7L1247.96 511.7L1248.66 511.7ZM1247.96 716L1252 709L1243.92 709L1247.96 716ZM1247.96 511.7L1247.26 511.7L1247.26 709.7L1247.96 709.7L1248.66 709.7L1248.66 511.7L1247.96 511.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_16">
            <path
              id="Vector_15"
              d="M415.042 590L419.083 583L411 583L415.042 590ZM415.742 538.7L415.742 538L414.342 538L414.342 538.7L415.042 538.7L415.742 538.7ZM415.042 583.7L415.742 583.7L415.742 538.7L415.042 538.7L414.342 538.7L414.342 583.7L415.042 583.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_17">
            <path
              id="Vector_16"
              d="M415.042 701L419.083 694L411 694L415.042 701ZM415.742 652.7L415.742 652L414.342 652L414.342 652.7L415.042 652.7L415.742 652.7ZM415.042 694.7L415.742 694.7L415.742 652.7L415.042 652.7L414.342 652.7L414.342 694.7L415.042 694.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_18">
            <path
              id="Vector_17"
              d="M415.042 1015L419.083 1008L411 1008L415.042 1015ZM415.742 966.7L415.742 966L414.342 966L414.342 966.7L415.042 966.7L415.742 966.7ZM415.042 1008.7L415.742 1008.7L415.742 966.7L415.042 966.7L414.342 966.7L414.342 1008.7L415.042 1008.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_19">
            <path
              id="Vector_18"
              d="M415.042 873L419.083 866L411 866L415.042 873ZM415.741 777.7L415.741 777L414.341 777L414.341 777.7L415.041 777.7L415.741 777.7ZM415.042 866.7L415.742 866.7L415.741 777.7L415.041 777.7L414.341 777.7L414.342 866.7L415.042 866.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_20">
            <path
              id="Vector_19"
              d="M34.5 334.5L977.5 334.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469">
              <text
                id="Section Divider Label"
                transform="translate(34 335)"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={0} y={26.196}>
                  Cell Membrane
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_21">
            <path
              id="Vector_20"
              d="M35.5 854.5L732.5 854.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_2">
              <text
                id="Section Divider Label_2"
                transform="translate(35 855)"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={0} y={26.196}>
                  Peripheral Tissue
                </tspan>
              </text>
            </g>
          </g>
          <path id="Vector 319" d="M373 789C386.667 786.667 414.2 787.2 415 808" stroke="#1A1A1A" />
          <g id="lines_22">
            <path
              id="Vector_21"
              d="M34.5 404.5L977.5 404.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
          </g>
          <g id="Report titles">
            <rect width={120} height={36} transform="translate(276 347)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={301.086} y={361.086}>
                Diffusion across{" "}
              </tspan>
              <tspan x={284.562} y={377.086}>
                the cell membrane
              </tspan>
            </text>
          </g>
          <g id="Report titles_2">
            <rect width={69} height={36} transform="translate(308 539)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={332.715} y={553.086}>
                Binds to{" "}
              </tspan>
              <tspan x={308.199} y={569.086}>
                ESR1 or ESR2
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <rect width={70} height={36} transform="translate(294 704)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={313.703} y={718.086}>
                Receptor{" "}
              </tspan>
              <tspan x={294.953} y={734.086}>
                Dimerisation
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <rect x={321.5} y={936.5} width={184} height={19} rx={9.5} fill="white" />
            <rect x={321.5} y={936.5} width={184} height={19} rx={9.5} stroke="#282828" />
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={337.961} y={950.086}>
                Estrogen Response Element
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <rect x={238.5} y={1022.5} width={360} height={47} fill="white" />
            <rect
              x={238.5}
              y={1022.5}
              width={360}
              height={47}
              stroke="#5220DD"
              strokeDasharray="2 2"
            />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={254.887} y={1050.09}>
                Receptor complex activates or represses hundreds of genes
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <rect width={67} height={20} transform="translate(532 887)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={532.766} y={901.086}>
                Coactivator
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={58} height={36} transform="translate(344 966)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={368.777} y={980.086}>
                Gene{" "}
              </tspan>
              <tspan x={344.309} y={996.086}>
                Expression
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect width={281} height={52} transform="translate(457 482)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={457} y={496.086}>
                E1, E2, E3{" "}
              </tspan>
              <tspan x={457} y={512.086}>
                All estrogen bind to receptors.{" "}
              </tspan>
              <tspan x={457} y={528.086}>
                {"Binding strength: E2>E1>E3. (E2 binds most strongly)"}
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <rect width={120} height={20} transform="translate(276 466)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={302.426} y={480.086}>
                (Aromatase)
              </tspan>
            </text>
          </g>
          <g id="Report titles_10">
            <rect width={120} height={20} transform="translate(132 652)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_10"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={141.176} y={666.086}>
                Estrogen Receptor
              </tspan>
            </text>
          </g>
          <g id="Report titles_11">
            <rect width={120} height={20} transform="translate(583 649)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_11"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={592.176} y={663.086}>
                Estrogen Receptor
              </tspan>
            </text>
          </g>
          <g id="Report titles_12">
            <text
              id="25-Hydroxy Vitamin D_12"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={734.379} y={644.086}>
                PROLIFERATIVE PATHWAY
              </tspan>
            </text>
          </g>
          <g id="Report titles_13">
            <rect width={125} height={20} transform="translate(945 630)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_13"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={945.238} y={644.086}>
                PROTECTIVE PATHWAY
              </tspan>
            </text>
          </g>
          <g id="Report titles_14">
            <rect width={185} height={20} transform="translate(1156 630)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_14"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={1156.44} y={644.086}>
                POTENTIALLY HARMFUL PATHWAY
              </tspan>
            </text>
          </g>
          <g id="Hormones">
            <g id="diamond_2">
              <path
                id="Vector_22"
                d="M412.371 294.443C412.783 294.332 413.217 294.332 413.629 294.443L437.219 300.763C439.026 301.248 440.679 299.594 440.195 297.787L433.874 274.197C433.764 273.785 433.764 273.352 433.874 272.94L440.195 249.35C440.679 247.543 439.026 245.889 437.219 246.374L413.629 252.694C413.217 252.805 412.783 252.805 412.371 252.694L388.781 246.374C386.974 245.889 385.321 247.543 385.805 249.35L392.126 272.94C392.236 273.352 392.236 273.785 392.126 274.197L385.805 297.787C385.321 299.594 386.974 301.248 388.781 300.763L412.371 294.443Z"
                stroke="#00BF86"
                strokeMiterlimit={10}
              />
            </g>
            <text
              id="Title"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0em"
            >
              <tspan x={390.388} y={311.405}>
                Androgen
              </tspan>
            </text>
          </g>
          <g id="Hormones_2">
            <g id="diamond_3">
              <text
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={407.597} y={516.767}>
                  E2
                </tspan>
              </text>
              <path
                id="Vector_23"
                d="M414.371 532.443C414.783 532.332 415.217 532.332 415.629 532.443L439.219 538.763C441.026 539.248 442.679 537.594 442.195 535.787L435.874 512.197C435.764 511.785 435.764 511.352 435.874 510.94L442.195 487.35C442.679 485.543 441.026 483.889 439.219 484.374L415.629 490.694C415.217 490.805 414.783 490.805 414.371 490.694L390.781 484.374C388.974 483.889 387.321 485.543 387.805 487.35L394.126 510.94C394.236 511.352 394.236 511.785 394.126 512.197L387.805 535.787C387.321 537.594 388.974 539.248 390.781 538.763L414.371 532.443Z"
                stroke="#FFC647"
                strokeMiterlimit={10}
              />
            </g>
          </g>
          <g id="Hormones_3">
            <g id="diamond_4">
              <text
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={1040.55} y={498.405}>
                  E1
                </tspan>
              </text>
              <path
                id="Vector_24"
                d="M1044.37 511.124C1044.78 511.014 1045.22 511.014 1045.63 511.124L1062.15 515.55C1063.95 516.034 1065.61 514.381 1065.12 512.574L1060.7 496.055C1060.59 495.643 1060.59 495.209 1060.7 494.797L1065.12 478.279C1065.61 476.472 1063.95 474.818 1062.15 475.303L1045.63 479.729C1045.22 479.839 1044.78 479.839 1044.37 479.729L1027.85 475.303C1026.05 474.818 1024.39 476.472 1024.88 478.279L1029.3 494.797C1029.41 495.209 1029.41 495.643 1029.3 496.055L1024.88 512.574C1024.39 514.381 1026.05 516.034 1027.85 515.55L1044.37 511.124Z"
                stroke="#FFC647"
                strokeMiterlimit={10}
              />
            </g>
          </g>
          <g id="Hormones_4">
            <g id="diamond_5">
              <text
                id="label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={1242.71} y={498.405}>
                  E2
                </tspan>
              </text>
              <path
                id="Vector_25"
                d="M1247.37 511.124C1247.78 511.014 1248.22 511.014 1248.63 511.124L1265.15 515.55C1266.95 516.034 1268.61 514.381 1268.12 512.574L1263.7 496.055C1263.59 495.643 1263.59 495.209 1263.7 494.797L1268.12 478.279C1268.61 476.472 1266.95 474.818 1265.15 475.303L1248.63 479.729C1248.22 479.839 1247.78 479.839 1247.37 479.729L1230.85 475.303C1229.05 474.818 1227.39 476.472 1227.88 478.279L1232.3 494.797C1232.41 495.209 1232.41 495.643 1232.3 496.055L1227.88 512.574C1227.39 514.381 1229.05 516.034 1230.85 515.55L1247.37 511.124Z"
                stroke="#FFC647"
                strokeMiterlimit={10}
              />
            </g>
          </g>
          <g id="Hormones_5">
            <g id="diamond_6">
              <text
                id="label_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={407.597} y={625.767}>
                  E2
                </tspan>
              </text>
              <path
                id="Vector_26"
                d="M414.371 641.443C414.783 641.332 415.217 641.332 415.629 641.443L439.219 647.763C441.026 648.248 442.679 646.594 442.195 644.787L435.874 621.197C435.764 620.785 435.764 620.352 435.874 619.94L442.195 596.35C442.679 594.543 441.026 592.889 439.219 593.374L415.629 599.694C415.217 599.805 414.783 599.805 414.371 599.694L390.781 593.374C388.974 592.889 387.321 594.543 387.805 596.35L394.126 619.94C394.236 620.352 394.236 620.785 394.126 621.197L387.805 644.787C387.321 646.594 388.974 648.248 390.781 647.763L414.371 641.443Z"
                stroke="#FFC647"
                strokeMiterlimit={10}
              />
            </g>
          </g>
          <g id="Hormones_6">
            <g id="diamond_7">
              <text
                id="label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={407.597} y={731.767}>
                  E2
                </tspan>
              </text>
              <path
                id="Vector_27"
                d="M414.371 747.443C414.783 747.332 415.217 747.332 415.629 747.443L439.219 753.763C441.026 754.248 442.679 752.594 442.195 750.787L435.874 727.197C435.764 726.785 435.764 726.352 435.874 725.94L442.195 702.35C442.679 700.543 441.026 698.889 439.219 699.374L415.629 705.694C415.217 705.805 414.783 705.805 414.371 705.694L390.781 699.374C388.974 698.889 387.321 700.543 387.805 702.35L394.126 725.94C394.236 726.352 394.236 726.785 394.126 727.197L387.805 750.787C387.321 752.594 388.974 754.248 390.781 753.763L414.371 747.443Z"
                stroke="#FFC647"
                strokeMiterlimit={10}
              />
              <path
                id="receptor-protein"
                d="M439.516 756.537L415.78 750.228C415.217 750.079 414.625 750.079 414.063 750.228L391.484 756.229C390.02 756.619 389 757.945 389 759.46L389 772.39C389 774.585 391.08 776.185 393.202 775.621L414.147 770.054C414.71 769.904 415.302 769.904 415.865 770.054L437.798 775.883C439.92 776.447 442 774.848 442 772.653V759.768C442 758.252 440.98 756.926 439.516 756.537Z"
                stroke="#1A1A1A"
              />
            </g>
          </g>
          <g id="Hormones_7">
            <g id="diamond_8">
              <text
                id="label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={332.597} y={793.767}>
                  E2
                </tspan>
              </text>
              <path
                id="Vector_28"
                d="M339.371 809.443C339.783 809.332 340.217 809.332 340.629 809.443L364.219 815.763C366.026 816.248 367.679 814.594 367.195 812.787L360.874 789.197C360.764 788.785 360.764 788.352 360.874 787.94L367.195 764.35C367.679 762.543 366.026 760.889 364.219 761.374L340.629 767.694C340.217 767.805 339.783 767.805 339.371 767.694L315.781 761.374C313.974 760.889 312.321 762.543 312.805 764.35L319.126 787.94C319.236 788.352 319.236 788.785 319.126 789.197L312.805 812.787C312.321 814.594 313.974 816.248 315.781 815.763L339.371 809.443Z"
                stroke="#FFC647"
                strokeMiterlimit={10}
              />
              <path
                id="receptor-protein_2"
                d="M364.516 818.537L340.78 812.228C340.217 812.079 339.625 812.079 339.063 812.228L316.484 818.229C315.02 818.619 314 819.945 314 821.46L314 834.39C314 836.585 316.08 838.185 318.202 837.621L339.147 832.054C339.71 831.904 340.302 831.904 340.865 832.054L362.798 837.883C364.92 838.447 367 836.848 367 834.653V821.768C367 820.252 365.98 818.926 364.516 818.537Z"
                stroke="#1A1A1A"
              />
            </g>
          </g>
          <g id="Hormones_8">
            <g id="diamond_9">
              <text
                id="label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={351.597} y={902.767}>
                  E2
                </tspan>
              </text>
              <path
                id="Vector_29"
                d="M358.371 918.443C358.783 918.332 359.217 918.332 359.629 918.443L383.219 924.763C385.026 925.248 386.679 923.594 386.195 921.787L379.874 898.197C379.764 897.785 379.764 897.352 379.874 896.94L386.195 873.35C386.679 871.543 385.026 869.889 383.219 870.374L359.629 876.694C359.217 876.805 358.783 876.805 358.371 876.694L334.781 870.374C332.974 869.889 331.321 871.543 331.805 873.35L338.126 896.94C338.236 897.352 338.236 897.785 338.126 898.197L331.805 921.787C331.321 923.594 332.974 925.248 334.781 924.763L358.371 918.443Z"
                stroke="#FFC647"
                strokeMiterlimit={10}
              />
            </g>
          </g>
          <g id="Hormones_9">
            <g id="diamond_10">
              <text
                id="label_8"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={467.597} y={902.767}>
                  E2
                </tspan>
              </text>
              <path
                id="Vector_30"
                d="M474.371 918.443C474.783 918.332 475.217 918.332 475.629 918.443L499.219 924.763C501.026 925.248 502.679 923.594 502.195 921.787L495.874 898.197C495.764 897.785 495.764 897.352 495.874 896.94L502.195 873.35C502.679 871.543 501.026 869.889 499.219 870.374L475.629 876.694C475.217 876.805 474.783 876.805 474.371 876.694L450.781 870.374C448.974 869.889 447.321 871.543 447.805 873.35L454.126 896.94C454.236 897.352 454.236 897.785 454.126 898.197L447.805 921.787C447.321 923.594 448.974 925.248 450.781 924.763L474.371 918.443Z"
                stroke="#FFC647"
                strokeMiterlimit={10}
              />
            </g>
          </g>
          <g id="gene-CYP19A1" {...geneGroupProps("CYP19A1", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M286 423C286 420.791 287.791 419 290 419H382C384.209 419 386 420.791 386 423V451C386 453.209 384.209 455 382 455H290C287.791 455 286 453.209 286 451V423Z"
                fill={cyp19a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={306.281} y={442.448}>
                  CYP19A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp19a1"
              groupId="gene-snps"
              genePalette={cyp19a1}
              startX={294}
              startY={457}
              snpCount={getGeneSnpCount("CYP19A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ESR1" {...geneGroupProps("ESR1", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M144 605C144 602.791 145.791 601 148 601H240C242.209 601 244 602.791 244 605V633C244 635.209 242.209 637 240 637H148C145.791 637 144 635.209 144 633V605Z"
                fill={esr1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={177.508} y={624.448}>
                  ESR1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="esr1"
              groupId="gene-snps_2"
              genePalette={esr1}
              startX={152}
              startY={639}
              snpCount={getGeneSnpCount("ESR1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ESR2" {...geneGroupProps("ESR2", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M591 605C591 602.791 592.791 601 595 601H687C689.209 601 691 602.791 691 605V633C691 635.209 689.209 637 687 637H595C592.791 637 591 635.209 591 633V605Z"
                fill={esr2.lozengeFill}
              />
              <text
                id="gene-lozenge-label_3"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={623.062} y={624.448}>
                  ESR2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="esr2"
              groupId="gene-snps_3"
              genePalette={esr2}
              startX={599}
              startY={639}
              snpCount={getGeneSnpCount("ESR2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD17B1" {...geneGroupProps("HSD17B1", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M1080 475C1080 472.791 1081.79 471 1084 471H1161C1163.21 471 1165 472.791 1165 475V491C1165 493.209 1163.21 495 1161 495H1084C1081.79 495 1080 493.209 1080 491V475Z"
                fill={hsd17b1.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1096.4} y={487.767}>
                  HSD17B1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="hsd17b1"
              groupId="gene-snps_4"
              genePalette={hsd17b1}
              startX={1088}
              startY={497}
              snpCount={getGeneSnpCount("HSD17B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="Frame 431">
            <rect
              x={733.5}
              y={659.5}
              width={199}
              height={415}
              stroke="#1A1A1A"
              strokeDasharray="4 4"
            />
            <g id="Frame 430">
              <g id="lines_23">
                <path
                  id="Vector_31"
                  d="M833.042 979L837.083 972L829 972L833.042 979ZM833.741 867.7L833.741 867L832.341 867L832.341 867.7L833.041 867.7L833.741 867.7ZM833.042 972.7L833.742 972.7L833.741 867.7L833.041 867.7L832.341 867.7L832.342 972.7L833.042 972.7Z"
                  fill="#1A1A1A"
                />
              </g>
              <g id="lines_24">
                <path
                  id="Vector_32"
                  d="M833.042 810L837.083 803L829 803L833.042 810ZM833.742 740.7L833.742 740L832.342 740L832.342 740.7L833.042 740.7L833.742 740.7ZM833.042 803.7L833.742 803.7L833.742 740.7L833.042 740.7L832.342 740.7L832.342 803.7L833.042 803.7Z"
                  fill="#1A1A1A"
                />
              </g>
              <g id="Report titles_15">
                <rect width={60} height={20} transform="translate(803 757)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_15"
                  fill="#FFC647"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={803.516} y={771.098}>
                    16a-OH-E1
                  </tspan>
                </text>
              </g>
              <g id="Report titles_16">
                <rect width={120} height={20} transform="translate(773 984)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_16"
                  fill="#282828"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={804.834} y={998.086}>
                    Detoxified
                  </tspan>
                </text>
              </g>
              <g id="Hormones_10">
                <g id="diamond_11">
                  <text
                    id="label_9"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={10}
                    letterSpacing="0em"
                  >
                    <tspan x={827.673} y={841.405}>
                      E3
                    </tspan>
                  </text>
                  <path
                    id="Vector_33"
                    d="M832.371 854.124C832.783 854.014 833.217 854.014 833.629 854.124L850.148 858.55C851.955 859.034 853.608 857.381 853.124 855.574L848.698 839.055C848.587 838.643 848.587 838.209 848.698 837.797L853.124 821.279C853.608 819.472 851.955 817.818 850.148 818.303L833.629 822.729C833.217 822.839 832.783 822.839 832.371 822.729L815.852 818.303C814.045 817.818 812.392 819.472 812.876 821.279L817.302 837.797C817.413 838.209 817.413 838.643 817.302 839.055L812.876 855.574C812.392 857.381 814.045 859.034 815.852 858.55L832.371 854.124Z"
                    stroke="#FFC647"
                    strokeMiterlimit={10}
                  />
                </g>
              </g>
              <g id="gene-CYP3A4" {...geneGroupProps("CYP3A4", onGeneClick)}>
                <g id="gene-lozenge_9">
                  <path
                    d="M792 703C792 700.791 793.791 699 796 699H871C873.209 699 875 700.791 875 703V719C875 721.209 873.209 723 871 723H796C793.791 723 792 721.209 792 719V703Z"
                    fill={cyp3a4.lozengeFill}
                  />
                  <text
                    id="gene-label_6"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={14}
                    letterSpacing="0em"
                  >
                    <tspan x={808.098} y={715.767}>
                      CYP3A4
                    </tspan>
                  </text>
                </g>
                <GeneSnpShapes
                  id="cyp3a4"
                  groupId="gene-snps_5"
                  genePalette={cyp3a4}
                  startX={800}
                  startY={725}
                  snpCount={getGeneSnpCount("CYP3A4", expectedSnps, geneColors)}
                />
              </g>
              <g id="gene-UGT/SULT" {...geneGroupProps("UGT/SULT", onGeneClick)}>
                <g id="gene-lozenge_10">
                  <path
                    d="M784 907C784 904.791 785.791 903 788 903H883C885.209 903 887 904.791 887 907V923C887 925.209 885.209 927 883 927H788C785.791 927 784 925.209 784 923V907Z"
                    fill={ugt_sult.lozengeFill}
                  />
                  <text
                    id="gene-label_7"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={14}
                    letterSpacing="0em"
                  >
                    <tspan x={800.069} y={919.767}>
                      UGT*/SULT
                    </tspan>
                  </text>
                </g>
                <GeneSnpShapes
                  id="ugt-sult"
                  groupId="gene-snps_6"
                  genePalette={ugt_sult}
                  startX={792}
                  startY={929}
                  snpCount={getGeneSnpCount("UGT/SULT", expectedSnps, geneColors)}
                />
              </g>
            </g>
          </g>
          <g id="Frame 432">
            <rect
              x={945.5}
              y={659.5}
              width={199}
              height={415}
              stroke="#1A1A1A"
              strokeDasharray="4 4"
            />
            <g id="Frame 430_2">
              <g id="lines_25">
                <path
                  id="Vector_34"
                  d="M1045.04 979L1049.08 972L1041 972L1045.04 979ZM1045.74 843.7L1045.74 843L1044.34 843L1044.34 843.7L1045.04 843.7L1045.74 843.7ZM1045.04 972.7L1045.74 972.7L1045.74 843.7L1045.04 843.7L1044.34 843.7L1044.34 972.7L1045.04 972.7Z"
                  fill="#1A1A1A"
                />
              </g>
              <g id="lines_26">
                <path
                  id="Vector_35"
                  d="M1045.04 817L1049.08 810L1041 810L1045.04 817ZM1045.74 736.7L1045.74 736L1044.34 736L1044.34 736.7L1045.04 736.7L1045.74 736.7ZM1045.04 810.7L1045.74 810.7L1045.74 736.7L1045.04 736.7L1044.34 736.7L1044.34 810.7L1045.04 810.7Z"
                  fill="#1A1A1A"
                />
              </g>
              <g id="Report titles_17">
                <rect width={48} height={20} transform="translate(1021 756)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_17"
                  fill="#FFC647"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1021.93} y={770.098}>
                    2-OH-E1
                  </tspan>
                </text>
              </g>
              <g id="Report titles_18">
                <rect width={50} height={20} transform="translate(1021 869)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_18"
                  fill="#FFC647"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1021.21} y={883.098}>
                    2-MeOE1
                  </tspan>
                </text>
              </g>
              <g id="Report titles_19">
                <rect width={49} height={20} transform="translate(1021 780)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_19"
                  fill="#FFC647"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1021.29} y={794.098}>
                    2-OH-E2
                  </tspan>
                </text>
              </g>
              <g id="Report titles_20">
                <rect width={52} height={20} transform="translate(1021 893)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_20"
                  fill="#FFC647"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1021.57} y={907.098}>
                    2-MeOE2
                  </tspan>
                </text>
              </g>
              <g id="Report titles_21">
                <rect width={120} height={20} transform="translate(985 980)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_21"
                  fill="#282828"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1016.83} y={994.086}>
                    Detoxified
                  </tspan>
                </text>
              </g>
              <g id="Report titles_22">
                <rect width={100} height={36} transform="translate(997 1011)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_22"
                  fill="#282828"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={10}
                  letterSpacing="0px"
                >
                  <tspan x={1008.1} y={1024.4}>
                    No DNA damage{" "}
                  </tspan>
                  <tspan x={1005.14} y={1040.4}>
                    Lowest cancer risk
                  </tspan>
                </text>
              </g>
              <g id="gene-CYP1A1" {...geneGroupProps("CYP1A1", onGeneClick)}>
                <g id="gene-lozenge_11">
                  <path
                    d="M1005 703C1005 700.791 1006.79 699 1009 699H1081C1083.21 699 1085 700.791 1085 703V719C1085 721.209 1083.21 723 1081 723H1009C1006.79 723 1005 721.209 1005 719V703Z"
                    fill={cyp1a1.lozengeFill}
                  />
                  <text
                    id="gene-label_8"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={14}
                    letterSpacing="0em"
                  >
                    <tspan x={1022.48} y={715.767}>
                      CYP1A1
                    </tspan>
                  </text>
                </g>
                <GeneSnpShapes
                  id="cyp1a1"
                  groupId="gene-snps_7"
                  genePalette={cyp1a1}
                  startX={1013}
                  startY={725}
                  snpCount={getGeneSnpCount("CYP1A1", expectedSnps, geneColors)}
                />
              </g>
              <g id="gene-COMT" {...geneGroupProps("COMT", onGeneClick)}>
                <g id="gene-lozenge_12">
                  <path
                    d="M1005 829C1005 826.791 1006.79 825 1009 825H1081C1083.21 825 1085 826.791 1085 829V845C1085 847.209 1083.21 849 1081 849H1009C1006.79 849 1005 847.209 1005 845V829Z"
                    fill={comt.lozengeFill}
                  />
                  <text
                    id="gene-label_9"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={14}
                    letterSpacing="0em"
                  >
                    <tspan x={1024.85} y={841.767}>
                      COMT
                    </tspan>
                  </text>
                </g>
                <GeneSnpShapes
                  id="comt"
                  groupId="gene-snps_8"
                  genePalette={comt}
                  startX={1013}
                  startY={851}
                  snpCount={getGeneSnpCount("COMT", expectedSnps, geneColors)}
                />
              </g>
              <g id="gene-UGT/SULT_2" {...geneGroupProps("UGT/SULT", onGeneClick)}>
                <g id="gene-lozenge_13">
                  <path
                    d="M996 933C996 930.791 997.791 929 1000 929H1095C1097.21 929 1099 930.791 1099 933V949C1099 951.209 1097.21 953 1095 953H1000C997.791 953 996 951.209 996 949V933Z"
                    fill={ugt_sult.lozengeFill}
                  />
                  <text
                    id="gene-label_10"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={14}
                    letterSpacing="0em"
                  >
                    <tspan x={1012.07} y={945.767}>
                      UGT*/SULT
                    </tspan>
                  </text>
                </g>
                <GeneSnpShapes
                  id="ugt-sult-2"
                  groupId="gene-snps_9"
                  genePalette={ugt_sult}
                  startX={1004}
                  startY={955}
                  snpCount={getGeneSnpCount("UGT/SULT", expectedSnps, geneColors)}
                />
              </g>
            </g>
          </g>
          <g id="Frame 433">
            <rect
              x={1156.5}
              y={659.5}
              width={356}
              height={415}
              stroke="#1A1A1A"
              strokeDasharray="4 4"
            />
            <g id="Frame 430_3">
              <g id="lines_27">
                <path
                  id="Vector_36"
                  d="M1233.04 979L1237.08 972L1229 972L1233.04 979ZM1233.74 843.7L1233.74 843L1232.34 843L1232.34 843.7L1233.04 843.7L1233.74 843.7ZM1233.04 972.7L1233.74 972.7L1233.74 843.7L1233.04 843.7L1232.34 843.7L1232.34 972.7L1233.04 972.7Z"
                  fill="#1A1A1A"
                />
              </g>
              <g id="lines_28">
                <path
                  id="Vector_37"
                  d="M1325.04 979L1329.08 972L1321 972L1325.04 979ZM1325.74 897.7L1325.74 897L1324.34 897L1324.34 897.7L1325.04 897.7L1325.74 897.7ZM1325.04 972.7L1325.74 972.7L1325.74 897.7L1325.04 897.7L1324.34 897.7L1324.34 972.7L1325.04 972.7Z"
                  fill="#1A1A1A"
                />
              </g>
              <g id="lines_29">
                <path
                  id="Vector_38"
                  d="M1321.03 875.793L1318.51 868.113L1313.12 874.136L1321.03 875.793ZM1278.68 836.956L1278.16 836.49L1277.23 837.533L1277.75 838L1278.22 837.478L1278.68 836.956ZM1316.33 871.592L1316.8 871.07L1278.68 836.956L1278.22 837.478L1277.75 838L1315.87 872.113L1316.33 871.592Z"
                  fill="#1A1A1A"
                />
              </g>
              <g id="lines_30">
                <text
                  id="Line Label"
                  transform="translate(1384.81 866) rotate(45)"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={6.66531} y={16.086}>
                    If not detoxified
                  </tspan>
                </text>
                <path
                  id="Vector_39"
                  d="M1363.85 887.95L1363.35 887.455L1362.36 888.445L1362.86 888.94L1363.35 888.445L1363.85 887.95ZM1433.45 958.546L1431.36 950.739L1425.65 956.454L1433.45 958.546ZM1363.35 888.445L1362.86 888.94L1428.5 954.586L1429 954.092L1429.49 953.597L1363.85 887.95L1363.35 888.445Z"
                  fill="#1A1A1A"
                />
              </g>
              <g id="lines_31">
                <path
                  id="Vector_40"
                  d="M1233.04 817L1237.08 810L1229 810L1233.04 817ZM1233.74 708.7L1233.74 708L1232.34 708L1232.34 708.7L1233.04 708.7L1233.74 708.7ZM1233.04 810.7L1233.74 810.7L1233.74 708.7L1233.04 708.7L1232.34 708.7L1232.34 810.7L1233.04 810.7Z"
                  fill="#1A1A1A"
                />
              </g>
              <g id="Report titles_23">
                <rect width={48} height={20} transform="translate(1209 756)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_23"
                  fill="#FFC647"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1209.34} y={770.098}>
                    4-OH-E1
                  </tspan>
                </text>
              </g>
              <g id="Report titles_24">
                <rect width={51} height={20} transform="translate(1209 869)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_24"
                  fill="#FFC647"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1209.62} y={883.098}>
                    4-MeOE1
                  </tspan>
                </text>
              </g>
              <g id="Report titles_25">
                <rect width={53} height={20} transform="translate(1302 877)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_25"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1302.85} y={891.086}>
                    Quinones
                  </tspan>
                </text>
              </g>
              <g id="Report titles_26">
                <rect width={50} height={20} transform="translate(1209 780)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_26"
                  fill="#FFC647"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1209.7} y={794.098}>
                    4-OH-E2
                  </tspan>
                </text>
              </g>
              <g id="Report titles_27">
                <rect width={53} height={20} transform="translate(1209 893)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_27"
                  fill="#FFC647"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1209.98} y={907.098}>
                    4-MeOE2
                  </tspan>
                </text>
              </g>
              <g id="Report titles_28">
                <rect width={57} height={20} transform="translate(1203 980)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_28"
                  fill="#282828"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1203.33} y={994.086}>
                    Detoxified
                  </tspan>
                </text>
              </g>
              <g id="Report titles_29">
                <rect width={57} height={20} transform="translate(1296 980)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D_29"
                  fill="#282828"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={12}
                  letterSpacing="0px"
                >
                  <tspan x={1296.33} y={994.086}>
                    Detoxified
                  </tspan>
                </text>
              </g>
              <g id="Report titles_30">
                <rect x={1377.5} y={968.5} width={108} height={63} fill="white" />
                <rect
                  x={1377.5}
                  y={968.5}
                  width={108}
                  height={63}
                  stroke="#5220DD"
                  strokeDasharray="2 2"
                />
                <text
                  id="25-Hydroxy Vitamin D_30"
                  fill="#282828"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={10}
                  letterSpacing="0px"
                >
                  <tspan x={1385} y={987.405}>
                    DNA adducts:{" "}
                  </tspan>
                  <tspan x={1385} y={1003.4}>
                    DNA damage{" "}
                  </tspan>
                  <tspan x={1385} y={1019.4}>
                    Highest cancer risk
                  </tspan>
                </text>
              </g>
              <g id="gene-CYP1B1" {...geneGroupProps("CYP1B1", onGeneClick)}>
                <g id="gene-lozenge_14">
                  <path
                    d="M1193 703C1193 700.791 1194.79 699 1197 699H1269C1271.21 699 1273 700.791 1273 703V719C1273 721.209 1271.21 723 1269 723H1197C1194.79 723 1193 721.209 1193 719V703Z"
                    fill={cyp1b1.lozengeFill}
                  />
                  <text
                    id="gene-label_11"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={14}
                    letterSpacing="0em"
                  >
                    <tspan x={1210.54} y={715.767}>
                      CYP1B1
                    </tspan>
                  </text>
                </g>
                <GeneSnpShapes
                  id="cyp1b1"
                  groupId="gene-snps_10"
                  genePalette={cyp1b1}
                  startX={1201}
                  startY={725}
                  snpCount={getGeneSnpCount("CYP1B1", expectedSnps, geneColors)}
                />
              </g>
              <g id="gene-COMT_2" {...geneGroupProps("COMT", onGeneClick)}>
                <g id="gene-lozenge_15">
                  <path
                    d="M1193 829C1193 826.791 1194.79 825 1197 825H1269C1271.21 825 1273 826.791 1273 829V845C1273 847.209 1271.21 849 1269 849H1197C1194.79 849 1193 847.209 1193 845V829Z"
                    fill={comt.lozengeFill}
                  />
                  <text
                    id="gene-label_12"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={14}
                    letterSpacing="0em"
                  >
                    <tspan x={1212.85} y={841.767}>
                      COMT
                    </tspan>
                  </text>
                </g>
                <GeneSnpShapes
                  id="comt-2"
                  groupId="gene-snps_11"
                  genePalette={comt}
                  startX={1201}
                  startY={851}
                  snpCount={getGeneSnpCount("COMT", expectedSnps, geneColors)}
                />
              </g>
              <g id="gene-UGT/SULT_3" {...geneGroupProps("UGT/SULT", onGeneClick)}>
                <g id="gene-lozenge_16">
                  <path
                    d="M1184 933C1184 930.791 1185.79 929 1188 929H1283C1285.21 929 1287 930.791 1287 933V949C1287 951.209 1285.21 953 1283 953H1188C1185.79 953 1184 951.209 1184 949V933Z"
                    fill={ugt_sult.lozengeFill}
                  />
                  <text
                    id="gene-label_13"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={14}
                    letterSpacing="0em"
                  >
                    <tspan x={1200.07} y={945.767}>
                      UGT*/SULT
                    </tspan>
                  </text>
                </g>
                <GeneSnpShapes
                  id="ugt-sult-3"
                  groupId="gene-snps_12"
                  genePalette={ugt_sult}
                  startX={1192}
                  startY={955}
                  snpCount={getGeneSnpCount("UGT/SULT", expectedSnps, geneColors)}
                />
              </g>
              <g id="gene-NQO1" {...geneGroupProps("NQO1", onGeneClick)}>
                <g id="gene-lozenge_17">
                  <path
                    d="M1289 933C1289 930.791 1290.79 929 1293 929H1365C1367.21 929 1369 930.791 1369 933V949C1369 951.209 1367.21 953 1365 953H1293C1290.79 953 1289 951.209 1289 949V933Z"
                    fill={nqo1.lozengeFill}
                  />
                  <text
                    id="gene-label_14"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Medium"
                    fontSize={14}
                    letterSpacing="0em"
                  >
                    <tspan x={1310.6} y={945.767}>
                      NQO1
                    </tspan>
                  </text>
                </g>
                <GeneSnpShapes
                  id="nqo1"
                  groupId="gene-snps_13"
                  genePalette={nqo1}
                  startX={1297}
                  startY={955}
                  snpCount={getGeneSnpCount("NQO1", expectedSnps, geneColors)}
                />
              </g>
            </g>
          </g>
          <g id="gene-HSD3B1" {...geneGroupProps("HSD3B1", onGeneClick)}>
            <g id="gene-lozenge_18">
              <path
                d="M1136 515C1136 512.791 1137.79 511 1140 511H1212C1214.21 511 1216 512.791 1216 515V531C1216 533.209 1214.21 535 1212 535H1140C1137.79 535 1136 533.209 1136 531V515Z"
                fill={hsd3b1.lozengeFill}
              />
              <text
                id="gene-label_15"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1152.15} y={527.767}>
                  HSD3B1
                </tspan>
              </text>
              <path
                id="*_3"
                d="M1225.88 508.754V510.477L1223.2 510.384L1224.73 512.692L1223.23 513.615L1221.88 511.123L1220.52 513.615L1219.02 512.692L1220.55 510.384L1217.88 510.477L1217.88 508.754L1220.55 508.846L1219.02 506.538L1220.52 505.615L1221.88 508.108L1223.23 505.615L1224.73 506.538L1223.2 508.846L1225.88 508.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="hsd3b1"
              groupId="gene-snps_14"
              genePalette={hsd3b1}
              startX={1144}
              startY={537}
              snpCount={getGeneSnpCount("HSD3B1", expectedSnps, geneColors)}
            />
          </g>
          <path
            id="receptor-protein_3"
            d="M349.463 643.516L355.772 619.78C355.921 619.217 355.921 618.625 355.772 618.063L349.771 595.484C349.381 594.02 348.055 593 346.54 593L333.61 593C331.415 593 329.815 595.08 330.379 597.202L335.946 618.147C336.096 618.71 336.096 619.302 335.946 619.865L330.117 641.798C329.553 643.92 331.152 646 333.347 646L346.232 646C347.748 646 349.074 644.98 349.463 643.516Z"
            stroke="#282828"
          />
          <path
            id="receptor-protein_4"
            d="M327.463 921.516L333.772 897.78C333.921 897.217 333.921 896.625 333.772 896.063L327.771 873.484C327.381 872.02 326.055 871 324.54 871L311.61 871C309.415 871 307.815 873.08 308.379 875.202L313.946 896.147C314.096 896.71 314.096 897.302 313.946 897.865L308.117 919.798C307.553 921.92 309.152 924 311.347 924L324.232 924C325.748 924 327.074 922.98 327.463 921.516Z"
            stroke="#282828"
          />
          <path
            id="receptor-protein_5"
            d="M390.537 873.484L384.228 897.22C384.079 897.783 384.079 898.375 384.228 898.937L390.229 921.516C390.619 922.98 391.945 924 393.46 924L406.39 924C408.585 924 410.185 921.92 409.621 919.798L404.054 898.853C403.904 898.29 403.904 897.698 404.054 897.135L409.883 875.202C410.447 873.08 408.848 871 406.653 871L393.768 871C392.252 871 390.926 872.02 390.537 873.484Z"
            stroke="#282828"
          />
          <path
            id="receptor-protein_6"
            d="M507.537 875.484L501.228 899.22C501.079 899.783 501.079 900.375 501.228 900.937L507.229 923.516C507.619 924.98 508.945 926 510.46 926L523.39 926C525.585 926 527.185 923.92 526.621 921.798L521.054 900.853C520.904 900.29 520.904 899.698 521.054 899.135L526.883 877.202C527.447 875.08 525.848 873 523.653 873L510.768 873C509.252 873 507.926 874.02 507.537 875.484Z"
            stroke="#282828"
          />
          <path
            id="receptor-protein_7"
            d="M442.463 921.516L448.772 897.78C448.921 897.217 448.921 896.625 448.772 896.063L442.771 873.484C442.381 872.02 441.055 871 439.54 871L426.61 871C424.415 871 422.815 873.08 423.379 875.202L428.946 896.147C429.096 896.71 429.096 897.302 428.946 897.865L423.117 919.798C422.553 921.92 424.152 924 426.347 924L439.232 924C440.748 924 442.074 922.98 442.463 921.516Z"
            stroke="#282828"
          />
          <path
            id="receptor-protein_8"
            d="M480.537 595.484L474.228 619.22C474.079 619.783 474.079 620.375 474.228 620.937L480.229 643.516C480.619 644.98 481.945 646 483.46 646L496.39 646C498.585 646 500.185 643.92 499.621 641.798L494.054 620.853C493.904 620.29 493.904 619.698 494.054 619.135L499.883 597.202C500.447 595.08 498.848 593 496.653 593L483.768 593C482.252 593 480.926 594.02 480.537 595.484Z"
            stroke="#282828"
          />
        </g>
      </g>
    </>
  );
};

const SvgEndocrineOestrogenDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1540}
    height={914}
    viewBox="0 204 1540 914"
    fill="none"
    {...props}
  >
    <EndocrineOestrogenDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18293_224291">
        <rect width={1540} height={1118} fill="white" />
      </clipPath>
      <clipPath id="clip1_18293_224291">
        <rect width={1540} height={914} fill="white" transform="translate(0 204)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEndocrineOestrogenDiagram;
